export default __webpack_public_path__ + "static/media/bowl1.5f66647e.jpg";